const englishTabs = {
  Dashboard: "Dashboard",
  NewSale: "New Sale",
  Sales: "Sales",
  Products: "Product",
  Accounts: "Accounts",
  Transactions: "Transactions",
  Reports: "Reports",
  StockMgmnt: "Stock Mgmnt",
  Settings: "Settings",
  TabsPermissions: "Tabs Permissions",
  dineInTab: "Dine In",
  Production: "Production",
  CashManagement: "Cash Management",
};

const arabicTabs = {
  Dashboard: "لوحة التحكم",
  NewSale: "بيع جديد",
  Sales: "المبيعات",
  Products: "المنتج",
  Accounts: "الحساب",
  Transactions: "المعاملات",
  Reports: "التقارير",
  StockMgmnt: "إدارة المخزون",
  Settings: "الإعدادات",
  TabsPermissions: "أذونات علامات التبويب",
  dineInTab: " تناول الطعام",
  Production: "الإنتاج",
  CashManagement: "إدارة النقد",
};


const englishPages = {
  PagesPermissions: "Pages Permissions",
  Product: "Product",
  Accounts: "Accounts",
  Transaction: "Transaction",
  Report: "Report",
  Products: "Products",
  Category: "Category",
  Customers: "Customers",
  Customer: "Customer",
  Suppliers: "Suppliers",
  Supplier: "Supplier",
  dineIn: "Dine In",
  StockControl: "Stock Control",
  Expense: "Expense",
  WareHouse: "WareHouse",
  Delivery: "Delivery",
  SalesInvoice: "Sales Invoice",
  ExpenseInvoice: "Expense Invoice",
  Setting: "Setting",
  StockActivity: "Stock Activity",
  StockValue: "Stock Value",
  Warranty: "Warranty",
  General: "General",
  Users: "Users",
  Role: "Role",
  SaleSettings: "Sale Settings",
  PiSettings: "Pi Settings",
  ProductSettings: "Product Settings",
  Lisence: "Lisence",
  PurchaseInvoice: "Purchase Invoice",
  ProductSales: "Product Sales",
  AllTransactions: "All Transactions",
  CashFlow: "Cash Flow",
  IncomeStatement: "Income Statement",
  Close: "Close",
  SaveData: "Save Data",
  Tables: "Tables",
  Sales: "Sales",
  Orders: "Orders",
  Categories: "Categories",
  Bank: "Bank",
  ChartOfAccounts: "Chart Of Accounts",
  Expenses: "Expenses",
  SalesReturn: "Sales Return",
  PurchaseReturn: "Purchase Return",
  Production: "Production",
  FinishedGoods: "Finished Goods",
  ByItems: "By Items",
  ByInvoice: "By Invoice",
  BalanceAndVariance: "Balance And Variance",
  CostChange: "Cost Change",
  Roles: "Roles",
  License: "License",
  Barcode: "Barcode",
  BackUp: "Back Up",
};

const arabicPages = {
  PagesPermissions: "أذونات صفحات المشرف",
  Product: "المنتج",
  Accounts: "الحسابات",
  Transaction: "المعاملات",
  Report: "التقرير",
  Products: "المنتجات",
  Sales: "المبيعات",
  Orders: "الطلبات",
  Category: "الفئة",
  Customer: "العميل",
  Supplier: "المورد",
  dineIn: " تناول الطعام",
  Tables: "الطاولات", 
  StockControl: "التحكم في المخزون",
  Expense: "المصروف",
  WareHouse: "المستودع",
  Delivery: "التسليم",
  Customers: "العملاء",
  Suppliers: "الموردون",
  Bank: "البنك",
  ChartOfAccounts: "دليل الحسابات",
  Expenses: "المصروفات",
  SalesInvoice: "فاتورة المبيعات",
  ExpenseInvoice: "فاتورة المصروف",
  Setting: "الإعدادات",
  StockActivity: "نشاط المخزون",
  StockValue: "قيمة المخزون",
  Warranty: "الضمان",
  General: "عام",
  Users: "المستخدمون",
  Role: "الدور",
  SaleSettings: "إعدادات المبيعات",
  PiSettings: "إعدادات الشراء",
  ProductSettings: "إعدادات المنتج",
  Lisence: "الترخيص",
  PurchaseInvoice: "فاتورة الشراء",
  ProductSales: "مبيعات المنتجات",
  AllTransactions: "جميع المعاملات",
  CashFlow: "التدفق النقدي",
  IncomeStatement: "بيان الدخل",
  Close: "إغلاق",
  SaveData: "حفظ البيانات",
  Categories: "الفئات",
  SalesReturn: "مرتجع مبيعات",
  PurchaseReturn: "مرتجع مشتريات",
  Production: "الإنتاج",
  FinishedGoods: "السلع التامة الصنع",
  ByItems: "حسب الأصناف",
  ByInvoice: "حسب الفاتورة",
  BalanceAndVariance: "الرصيد والانحراف",
  CostChange: "تغيير التكلفة",
  Roles: "الأدوار",
  License: "الترخيص",
  Barcode: "الرمز الشريطي",
  BackUp: "نسخ احتياطي",

};


const englishContent = {
  Item: "Item",
  Price: "Price",
  Dis: "Dis",
  Net: "Net",
  Qnty: "Qnty",
  Category: "Category",
  Total: "Total",
  TotalPrice: "Total Price",
  Discount: "Discount",
  FinalPrice: "Final Price:",
  PayCash: "Pay Cash",
  PayCredit: "Pay Credit",
  ClosingHour: "Closing Hour",
  DefaultDate: "Default Date",
  LowInStock: "Low In Stock",
  ShowZeroStock: "Show Zero Stock",
  TVA: "TVA %",
  DefaultUseTVA: "Default Use TVA",
  PrintDirect: "Print Direct",
  Language: "Language",
  CostChangerMethod: "Cost Changer Method",
  MoneyExchange: "Money Exchange",
  Currency: "Currency",
  IsRated: "isRated",
  Rate: "Rate",
  RatingFormula: "Rating Formula",
  RatedCurrency: "Rated Currency",
  ShowRateOnInvoice: "Show rate on invoice",
  ShowPriceBeforeDiscount: "Show Price Before Discount",
  ShowWareHouseInSales: "Show WareHouse In Sales",
  FilterSalesByDate: "Filter Sales By Date",
  Serial: "Serial",
  Cost: "Cost",
  ReturnCash: "Return Cash",
  ReturnCredit: "Return Credit",



};

const arabicContent = {
  Item: "العنصر",
  Price: "السعر",
  Dis: "الخصم",
  Net: "الصافي",
  Qnty: "الكمية",
  Total: "الإجمالي",
  TotalPrice: "السعر الإجمالي",
  Category: "الفئة",
  Discount: "الخصم",
  FinalPrice: "السعر النهائي:",
  PayCash: "الدفع نقدًا",
  PayCredit: "الدفع بالائتمان",
  ClosingHour: "ساعة الإغلاق",
  DefaultDate: "التاريخ الافتراضي",
  LowInStock: "منخفض المخزون",
  ShowZeroStock: "إظهار المخزون الصفري",
  TVA: "الضريبة %",
  DefaultUseTVA: "الاستخدام الافتراضي للضريبة",
  PrintDirect: "الطباعة المباشرة",
  Language: "اللغة",
  CostChangerMethod: "طريقة تغيير التكلفة",
  MoneyExchange: "صرف الأموال",
  Currency: "العملة",
  IsRated: "مُقَيَّم",
  Rate: "السعر",
  RatingFormula: "معادلة التقييم",
  RatedCurrency: "العملة المُقَيَّمة",
  ShowRateOnInvoice: "إظهار السعر في الفاتورة",
  ShowPriceBeforeDiscount: "إظهار السعر قبل الخصم",
  ShowWareHouseInSales: "إظهار المستودع في المبيعات",
  FilterSalesByDate: "تصفية المبيعات حسب التاريخ",
  Serial: "الرقم التسلسلي",
  Cost: "التكلفة",
  ReturnCash: "إرجاع نقدي",
  ReturnCredit: "إرجاع آجل",


};


export { 
englishTabs,
englishPages,
englishContent,
arabicTabs,
arabicPages,
arabicContent,
};